// translations/pages/landing/ja.js

export const landingPageJA = {
  "hero": {
    "title": "pAIoneer Labs GmbH",
    "subtitle": "データ保護を重視したローカルAIソリューション",
    "vision": "生産性向上の次の段階、Organisation as a Service。AI社員が、アイデアから検証済みの成果までの仕事を引き受けます。",
    "intro": "私たちは人工知能、機械学習、データ処理の技術を研究・開発・統合しています。そこから、ローカル環境や顧客自身のITインフラ内でデータを分析・構造化・匿名化・保護する自社製品やカスタムソリューションが生まれ、さらに [Veridion](veridion) によって、人と協働して企業の業務領域全体を丸ごと担う完全自動化されたAI社員を実現しています。",
    "detail": "当社がお客様のもとに導入するソフトウェアは、お客様自身のインフラで稼働し、クラウドへの接続を必要としません。文書、データ、言語モデルは社内にとどまります。"
  },
  "partners": {
    "title": "当社を信頼するパートナー",
    "subtitle": "当社のAI組織が本番環境で稼働している企業および研究機関です。",
    "items": {
      "bisigma": {
        "name": "BiSigma",
        "tagline": "BioSignal Measurement and Analysis\n研究のためのアイトラッキングおよび生体信号ソリューション",
        "description": [
          "BiSigmaは、生体信号の計測・解析システム、ならびに学術・臨床・産業研究向けの高精度アイトラッキングソリューションを専門としています。",
          "pAIoneer Labs GmbHはBiSigmaにおいてソフトウェア開発を完全にAIに置き換えており、そのAIが生体信号の計測・解析ソフトウェアの開発と継続的な進化を成功裏に担っています。"
        ],
        "cta": "BiSigmaを見る"
      }
    }
  },
  "products": {
    "title": "製品",
    "subtitle": "当社は、職場向けのデスクトップアプリケーション、オンプレミスまたはお客様のクラウドで稼働するサーバーソフトウェア、そして、当社のAI社員が自ら開発する[トレーディングアシスタント](finance)など当社プラットフォーム上のサブスクリプションとして、ソフトウェアを販売しています。また、お客様の要件に応じたAIシステムを開発し、コンサルティングと研修を提供しています。",
    "partnerLabel": "パートナー製品",
    "priceOnRequest": "価格はお問い合わせください",
    "request": "メールで問い合わせる",
    "items": {
      "kyveil": {
        "name": "Kyveil Desktop",
        "description": [
          "Kyveilは、Word、Excel、OpenDocument、PDF、テキストの各ファイルに含まれる個人データを、AIツール、テスト、分析に渡る前や第三者に提供される前に検出し、匿名化します。検出には{presidio}、{spacy}、{flair}を組み合わせて使用し、ドイツ語、英語、フランス語、イタリア語、スペイン語に対応しています。",
          "デスクトップ版は、Windows、macOS、Linuxを搭載した一般的なコンピューター上で、GPUを必要とせず、ネットワークにも依存せずに単独で動作し、ファイルがワークステーションの外に出ることはありません。API版はお客様のインフラ上で、オンプレミスまたはお客様自身のクラウドで稼働し、既存のシステムやワークフローに匿名化を組み込みます。",
          "置換モードはコンプライアンス文書向けに個人データをプレースホルダーに、擬似データモードはテスト環境向けにもっともらしい代替値に置き換え、文書の構造はそのまま保たれます。AnonChatでは、匿名化された文書は、プレビューを経てはじめてChatGPT、Claude、Gemini、または社内の言語モデルに渡されます。"
        ],
        "cta": "Kyveilを見る"
      },
      "veridion": {
        "name": "Veridion Agentic Company Intelligence",
        "claim": "一つの創り手、無限の解決策。",
        "text": [
          "pAIoneer Labs GmbHの社内AI。ソフトウェア開発からエレクトロニクスと量子コンピューティングを経て、営業と管理に至るビジネスユニットを備え、独自の調整層に率いられた、AI社員からなる一つの完全な組織として、企業全体を動かしています。",
          "この働き手は、プロジェクト、簿記、企業ナレッジ、調査、開発、データ分析を自ら最後までやり遂げます。そのコミュニケーションはゲーム理論で最適化されており、まだ存在しない能力が必要になれば、そのための独自のAIシステムを自ら構築します。",
          "稼働するのは、オンプレミス、お客様自身のクラウド、または当社のプラットフォームです。そこで[トレーディングアシスタント](finance)を自ら開発し、そのチャットの中のAIでもあります。"
        ],
        "points": [
          "あらゆるプロセスに溶け込みます",
          "自ら学び続けます",
          "足りない能力は自ら創り出します",
          "固定のサイクルで計画できます"
        ],
        "cta": "Veridionを見る"
      },
      "robuddy": {
        "name": "RoBuddy",
        "description": [
          "RoBuddyは、企業向けのAIベースのモジュール型エージェントシステムで、事務管理業務を自動化します。",
          "5つの役割が日々の業務をカバーします。アシスタントは、予定を調整し、メールの下書きを作成し、日常のタスクを処理します。コーチは、仕事における感情面や対人面に寄り添い、対立の解決を助け、個人の成長を支援します。データ保護ヘルパーは、データ保護とプライバシーに関する専門的な質問に答え、防火やコンプライアンスなど、さらに別の専門分野について学習させることもできます。研修トレーナーは、研修計画、オンボーディング、研修モジュールを作成し、アドバイザーは、アップロードされた文書を分析し、意思決定を支援し、戦略的な提言を行います。",
          "RoBuddyは、100%ドイツの基準（GDPR、BSI-Grundschutz）に準拠してホスティング・管理されており、Nextcloudやあらゆるネットワークドライブにシームレスに接続できます。",
          "RoBuddyはオフィスワークのためのエージェント型システムで、Veridionと組み合わせることで、企業全体をカバーする一つの社内AIになります。RoBuddyは職場でのタスクを担い、Veridionは企業のシステムとデータを接続します。"
        ],
        "cta": "RoBuddyを見る",
        "vendorNote": "RoBuddyは、Dr. Hornecker Software-Entwicklung und IT-Dienstleistungenの製品です。販売はpAIoneer Labs GmbHが行っています。"
      }
    }
  },
  "platformNote": {
    "title": "SaaSプラットフォーム",
    "description": "このアプリケーションは、インストール不要で、サブスクリプションによりブラウザから直接ご利用いただけます。当社独自のプラットフォーム上で稼働し、ログインには二要素認証が必要で、すべてのAI呼び出しは、固定の利用枠を設けた一つの中央アクセスポイントを経由します。",
    "apps": {
      "finance": {
        "name": "AIトレーディングアシスタント",
        "text": "お使いの証券口座を連携し、保有ポジションについて普段の言葉で質問して、どのニュースが値動きにつながったかを確認できます。金融商品ごとに、毎日再学習される専用の機械学習モデルが予測を算出し、シグナルは自動売買機能で取引できます。このアシスタントは当社のAI社員が開発しており、チャットの中のAIも同じAI社員です。",
        "cta": "トレーディングアシスタントを見る"
      }
    }
  },
  "services": {
    "title": "主要サービス",
    "veridion": {
      "title": "AI社員",
      "description": "仕事の分野を丸ごと、企業のプロセスとツールに溶け込み、仕事を自ら最後までやり遂げるAI社員が担います。当社自身がこの形で働いています。pAIoneer Labs GmbHは、この上で動いています。",
      "cta": "Veridionを見る",
      "features": [
        "Organisation as a Service",
        "AI社員からなるビジネスユニット",
        "ゲーム理論で最適化されたコミュニケーション",
        "オンプレミスまたはお客様自身のクラウド"
      ]
    },
    "custom": {
      "title": "お客様ごとのAIシステム",
      "description": "当社は、データの分析、処理、構造化、匿名化、保護を行うシステムをお客様の要件に合わせて開発し、ローカルまたはお客様所有のITインフラに統合します。",
      "features": [
        "クラウドを使わない運用",
        "製品開発",
        "プロトタイプ",
        "研究開発プロジェクト"
      ]
    },
    "dataanalysis": {
      "title": "対話によるデータ分析",
      "description": "AI社員が、接続されたデータソースに対する質問に答えます。データベースのカタログ、スキーマ、列を読み取り、データにアクセスする前に分析計画を提示し、あいまいな点を確認します。",
      "features": [
        "SQLデータソース",
        "相関と回帰",
        "表とグラフ",
        "PDFおよびPowerPointへのエクスポート"
      ]
    },
    "memory": {
      "title": "企業の記憶",
      "description": "文書検索ではなく、記憶です。事実、意思決定、タスク、手順が、それらの属するプロジェクト、人、システム、文書と結び付けられ、それが有効である時間とともに保持されます。会話、会議、仕事の成果から自ずと育ち、同じテーマのより新しい意思決定が古いものに取って代わります。失われるものはありません。",
      "features": [
        "ナレッジグラフ",
        "時間を伴う事実",
        "失われない意思決定",
        "責任範囲に応じたアクセス"
      ]
    },
    "elektronik": {
      "title": "エレクトロニクスとファームウェア",
      "description": "ハードウェアに近い開発をサービスとして。回路設計とデジタルツインとしてのシミュレーション、センサーに至るまでのファームウェア、製造の前に行う部品と代替案の評価。",
      "features": [
        "デジタルツイン",
        "組み込みファームウェア",
        "データシート分析",
        "部品の評価"
      ]
    },
    "quantum": {
          "title": "ソブリンLLM＆量子AI",
          "description": "Veridionのもとでの私たちの目標：将来的に米中の大規模モデルに対抗するドイツ製コンパクト言語モデルと、独自の量子トランスフォーマーを開発することです。",
          "cta": "Quantumを見る",
          "features": [
                "ドイツ製ソブリンLLM",
                "量子トランスフォーマー",
                "自社製Quantum IDE",
                "AIがAIを開発"
          ]
    },
    "kyveil": {
      "title": "GPU不要のローカル匿名化",
      "description": "Kyveilは、Windows、macOS、Linuxを搭載した一般的なコンピューター上のデスクトップアプリケーションとして、またはお客様のインフラ上のREST APIとして、クラウドへの依存もGPUも必要とせずに、個人データをローカルで匿名化します。",
      "cta": "Kyveilを見る",
      "features": [
        "AI利用前の匿名化",
        "NLPによるPII検出",
        "Windows、macOS、Linux",
        "オンプレミスのREST API"
      ]
    },
    "agenticdev": {
      "title": "Intent-Driven Development",
      "description": "AI支援ソフトウェア開発には、信頼できるコンテキストが欠かせません。IDDは、目標、非目標、シナリオ、エージェントのルール、意思決定を、活用できるプロジェクトの記憶として記録します。",
      "cta": "IDDを見る",
      "features": [
        "エージェント型開発",
        "IDD Vault",
        "Intent/Decisions/Scenarios",
        "テストとしてのシナリオ"
      ]
    },
    "finance": {
      "title": "金融・市場分析",
      "description": "トレーディングアシスタントの背後には、デジタル社員からなる独自のビジネスユニットが立っています。AIデータサイエンティストと金融の専門家です。ニュースをリアルタイムで評価し、金融ニュースの感情を分析し、チャットの中で市場データに対して自ら計算を行います。相関、回帰、グラフ、そして自らの予測の成績。そのすべての数値は、実行された計算ステップから得られたものです。その基盤では、金融商品ごとの機械学習予測と、ペーパートレードと実取引の自動売買が稼働しています。",
      "cta": "金融AIを見る",
      "features": [
        "AIデータサイエンティストと金融の専門家",
        "リアルタイムのニュースと感情分析",
        "金融商品ごとの機械学習予測",
        "自動売買"
      ]
    },
    "consulting": {
      "title": "コンサルティング",
      "description": "当社は、AIの導入、安全確保、ルールに準拠した活用について、技術、組織、戦略の各面からコンサルティングを行います。",
      "features": [
        "AIガバナンス",
        "データマネジメント",
        "データ保護",
        "情報セキュリティ"
      ]
    }
  },
  "contact": {
    "title": "お問い合わせ",
    "addressLabel": "所在地",
    "phoneLabel": "電話",
    "emailLabel": "メール",
    "cta": "メッセージを送る"
  }
};
